import useSWR from 'swr/immutable';
import { FinanceService } from 'services/finance.service';

export const useCurrencyInfo = (currencyCode: string | null) => {
  return useSWR(
    currencyCode ? currencyCode : null,
    () => FinanceService.getCurrencyInfo(currencyCode || ''),
    { revalidateOnMount: true, revalidateOnFocus: false }
  );
};